import { StowageRulesMapsBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRulesMapsBM';
import { Product } from 'src/types/ViewModel/Stowage/Product/Product';
import { ProductCategory } from 'src/types/ViewModel/Stowage/Product/ProductCategory';
import { commodityBookStowageRules } from './stowageRulesManager/stowageRulesUtils';
import { ProductAllowanceEnum } from 'src/types/BusinessModel/Stowage/Product/ProductAllowanceEnum';

// TODO: FUNCTION-MUTATION - Function mutates input parameters (productList and productCategoryList) by adding properties. This violates functional programming principles and can cause unexpected side effects. Consider returning new objects instead of mutating inputs.
export function mapProducts(productList: Product[], productCategoryList: ProductCategory[], stowageRulesMapBM: StowageRulesMapsBM): void {
    productCategoryList.forEach((pc) => {
        pc.stowageRules = commodityBookStowageRules.filter((sr) =>
            stowageRulesMapBM.stowageRuleProductCategoryMap.some((srpcm) => srpcm.productCategoryId === pc.id && srpcm.stowageRuleId === sr.id)
        );
    });

    productList.forEach((p) => {
        p.category = productCategoryList.find((pc) => pc.id === p.categoryId);
        p.stowageRules = commodityBookStowageRules.filter((sr) =>
            stowageRulesMapBM.stowageRuleProductMap.some((srpm) => srpm.productId === p.id && srpm.stowageRuleId === sr.id)
        );
    });
}

export function getFosfaListStatus(product: Product): string {
    switch (product.fosfaAllowance) {
        case ProductAllowanceEnum.Acceptable:
            return 'On FOSFA list of acceptable previous cargoes';
        case ProductAllowanceEnum.Banned:
            return 'On FOSFA list of banned immediate previous cargoes';
        case ProductAllowanceEnum.NotListed:
            return 'Not on FOSFA lists';
        default:
            return 'FOSFA status not specified';
    }
}
